import { render } from "./ConversationInterface.vue?vue&type=template&id=958256b4"
import script from "./ConversationInterface.vue?vue&type=script&lang=js"
export * from "./ConversationInterface.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__